import { render, staticRenderFns } from "./my_team.vue?vue&type=template&id=6c4b890f&"
import script from "./my_team.vue?vue&type=script&lang=js&"
export * from "./my_team.vue?vue&type=script&lang=js&"
import style0 from "./my_team.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports